/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var TasksIcon = createIcon("TasksIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.587 2a.5.5 0 01.498.552l-1.873 18a.5.5 0 01-.498.448H2a2 2 0 01-2-2V4a2 2 0 012-2h6.587Z",
    fill: "#FF9E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.053 20.956-3.173.952a2.182 2.182 0 01-2.719-1.464L2.092 6.88a2.183 2.183 0 011.464-2.719l5.246-1.574 2.522-.756L17.12.092a2.185 2.185 0 012.719 1.464l4.069 13.564a2.183 2.183 0 01-1.464 2.719l-.888.266-9.503 2.851Z",
    fill: "#FFC06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.392 3.436.524.787a.5.5 0 01-.832.554l-.564-.845A2.003 2.003 0 018 2a2 2 0 113.392 1.436Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.267 6.83a.5.5 0 11.883.469l-3.254 6.118a.5.5 0 01-.676.207L9.598 12.23a.5.5 0 01.47-.883l2.18 1.16 3.019-5.678Z",
    fill: "#333"
  })));
}, {});